import React, { useContext, useEffect, useRef, useState } from 'react'
import { Toast } from 'primereact/toast';
import { Dialog } from 'primereact/dialog'
import { Calendar } from 'primereact/calendar';
import { InputText } from 'primereact/inputtext';
import { InputNumber } from 'primereact/inputnumber';
import { Checkbox } from 'primereact/checkbox';
import { InputMask } from 'primereact/inputmask';
import { InputTextarea } from 'primereact/inputtextarea';
import { Button } from 'primereact/button';

import Card from '../../../../Base/Components/Card/Card';
import AutoCompleteDropdown from '../../../../Base/Components/Form/AutoCompleteDropdown';
import Loader from '../../../../Base/Components/Loader/Loader';
import { useForm } from '../../../../Base/Hooks/useForm';
import { toastShow } from '../../../../Base/Services/ToastService';
import { AuthContext } from '../../../../Base/Context/AuthContext/AuthContext';


import { getEstadosClientesIPS } from '../../../API/Global/Estados/StatusRequest'
import { addCustomer, getInfoCustomer, postCustomer } from '../../../API/Clientes/ClientesRequest';
import { getTiposPagosClientes } from '../../../API/Global/TiposPago/TipoPagosRequest'
import { getUnidades } from '../../../API/Global/Unidades/UnidadesRequest';
import { getTerminosIncoterms, getTerminosPaymentTerms } from '../../../API/Global/Terminos/TerminosRequest';
import { getPaises } from '../../../API/Global/Paises/PaisesRequest';

// import { getEstadosClientesIPS } from '../../../../API/Global/Estados/StatusRequest';
// import { getTiposPagosClientes } from '../../../../API/Global/TiposPago/TipoPagosRequest';
// import { getUnidades } from '../../../../API/Global/Unidades/UnidadesRequest';
// import { getTerminosIncoterms, getTerminosPaymentTerms } from '../../../../API/Global/Terminos/TerminosRequest';
// import { getPaises } from '../../../../API/Global/Paises/PaisesRequest';


const ModalClientes = ({ clientesDialog, setClientesDialog, IdCustomer, setIdCustomer, getListadoClientes, Finanzas }) => {
    const toast= useRef(null)
    const {userAuth} = useContext(AuthContext);

    const IdHonduras = 95;
    
    const [loading, setLoading] = useState(false);
    const [terminosPayment, setTerminosPayment] = useState([]);
    const [terminosIncoterms, setTerminosIncoterms] = useState([])
    const [unidades, setUnidades] = useState([]);
    const [tipoPagos, setTipoPagos] = useState([]);
    const [estados, setEstados] = useState([]);
    const [Countries, setCountries] = useState([]);

    const valoresInicio = {
        IdCustomer: -1,
        PorcentajePenalizacion: 3,
        Estado: {
            IdStatus: 1,
            StatusName: 'Active'
        }
    }

    const {values, handleInputChange, setValues,resetForm, error, setError} = useForm(valoresInicio);

    const getInfo = async (idCustomer) => {
        setLoading(true);
        const tempoTerminosP = await getTerminosPaymentTerms()
        
        const tempoTerminosI = await getTerminosIncoterms()

        const tempoUnidades = await getUnidades();

        const tempoTipoPagos = await getTiposPagosClientes();

        const tempoEstados = await getEstadosClientesIPS();

        const contriesT = await getPaises();

        if (idCustomer) {
          const infoCust = await getInfoCustomer(idCustomer)
          if (infoCust.length > 0) {
            const cust = infoCust[0]
            // console.log(cust);
            setValues({
              ...cust,
              DateCreate : new Date(cust?.DateCreate),
              Estado: tempoEstados.find(e => e.IdStatus === cust?.IdStatus) || valoresInicio.Estado,
              Pais: contriesT.find(e => e.Id === cust?.IdCountry),
              TiPago: tempoTipoPagos.find(e => e.IdTipoPago === cust?.IdTipoPago),
              Units: tempoUnidades.find(e => e.IdUnit === cust?.IdOrderUnits),
              TerminosP: tempoTerminosP.find(e => e.IdTerm === cust?.IdTerms),
              TerminosI: tempoTerminosI.find(e => e.IdTerm === cust?.IdFreightTerms),
            });
          } else {
            toastShow(toast, 'warn', 'Cliente no encontrado')
          }
        } else {
          setValues({
            ...valoresInicio,
            DateCreate : new Date(),
            Estado: tempoEstados.find(e => e.IdStatus === valoresInicio.Estado.IdStatus) || valoresInicio.Estado
          });
        }
        setTerminosPayment(tempoTerminosP);
        setTerminosIncoterms(tempoTerminosI);
        setUnidades(tempoUnidades);
        setTipoPagos(tempoTipoPagos);
        setEstados(tempoEstados);
        setCountries(contriesT);

        setLoading(false);
    }

    const verificarCampos = () => {
        let error = {}
        let showCompleteFieldsError = true

        if (!values.CustomerName) {
            error.CustomerName = true;
            error.error = true;
        }

        // if (!values.Abreviacion) {
        //     error.Abreviacion = true;
        //     error.error = true;
        // }

        if (!values.RTN) {
            error.RTN = true;
            error.error = true;
        }

        if (!values.Address) {
            error.Address = true;
            error.error = true;
        }


        if (!values.City) {
            error.City = true;
            error.error = true;
        }


        // if (!values.State) {
        //     error.State = true;
        //     error.error = true;
        // }


        if (!values.Pais || !values.Pais.Id) {
            error.Pais = true;
            error.error = true;
        }

        if (!values.Estado || !values.Estado.IdStatus) {
            error.Estado = true;
            error.error = true;
        }

        if (!values.Tel) {
            error.Tel = true;
            error.error = true;
        }

        if (!values.Email) {
            error.Email = true;
            error.error = true;
        } 
        // else if (!values.Email.includes('@')) {
        //     toastShow(toast, 'error', 'Error', 'Formato de Correo invalido.');
        //     error.Email = true;
        //     error.error = true;
        //     showCompleteFieldsError = false;
        // }

        
        
        
        // if(Finanzas.Finanzas){
        //     if (!values.TerminosP || !values.TerminosP.IdTerm) {
        //         error.TerminosP = true;
        //         error.error = true;
        //     }
        //     if (!values.TiPago || !values.TiPago.IdTipoPago) {
        //         error.TiPago = true;
        //         error.error = true;
        //     }
        //     if (!values.PorcentajePenalizacion) {
        //         error.PorcentajePenalizacion = true;
        //         error.error = true;
        //     } 
        // }

        // if (!values.TerminosI || !values.TerminosI.IdTerm) {
        //     error.TerminosI = true;
        //     error.error = true;
        // }

        if (error.error && showCompleteFieldsError) {
            toastShow(toast, 'error', 'Error', 'Complete los campos requeridos');
        }

        setError(error);
        return error;
    }

    const guardarCliente = async() => {
        const verificiar = verificarCampos();

        // console.log(verificiar.error)

        if (verificiar.error) {
            return;
        }

        const Datos = {
            IdCustomer: values?.IdCustomer,
            CodigoCliente: values?.CodigoCliente,
            RTN: values?.RTN,
            CustomerName: values?.CustomerName,
            Abreviacion: values?.Abreviacion,
            IdStatus: values?.Estado.IdStatus,
            Comments: values?.Comments,
            IsShipTo: values?.IsShipTo,
            IsBillTo: values?.IsBillTo,
            IdCountry: values?.IdCountry ? values.IdCountry : values?.Pais.Id,
            State: values?.State,
            City: values?.City,
            Address: values?.Address,
            ZipCode: values?.ZipCode,
            Tel: values?.Tel,
            Email: values?.Email,
            Contact: values?.Contact,
            Tel2: values?.Tel2,
            Email2: values?.Email2,
            Contact2: values?.Contact2,
            TipoPago: values?.TiPago ? values?.TiPago.IdTipoPago : null,
            IdOrderUnits: values?.Units ? values?.Units.IdUnit : null,
            IdTerms: values?.TerminosP ? values?.TerminosP.IdTerm : null,
            IdFreightTerms: values?.TerminosI ? values?.TerminosI.IdTerm : null,
            CreditLimit: values?.CreditLimit,
            Porcentaje: values?.Porcentaje,
            IdUserEditWeb: userAuth.idUser,
            PorcentajePenalizacion: values?.PorcentajePenalizacion,
        }

        if (Datos.IdCustomer > 0) {
            setLoading(true);
            const resultado = await postCustomer(Datos);
            if(resultado){
                toastShow(toast, "success", "Datos Editados", 'Datos editados correctamente');
                setTimeout(() => {
                hideDialog();
                setLoading(false);
                }, 1300);
            }else{
                toastShow(toast, "error", "Error",'Error al editar Cliente');
            }
          } else {
            const resultado = await addCustomer(Datos);
            if(resultado){
                toastShow(toast, "success", "Datos Agregados",'Datos agregados correctamente');
                setTimeout(() => {
                    hideDialog();
                    setLoading(false);
                }, 1300);
            }else{
                toastShow(toast, "error", "Error",'Error al agregar Cliente');
            }
           
        }
    }

    const hideDialog = () =>{
        setClientesDialog(false)
        resetForm();
        setError(false);
        setIdCustomer(0)
        setValues([])
        getListadoClientes()
    }

    useEffect(() => {
        if (clientesDialog) {
            getInfo(IdCustomer)
        }
    }, [clientesDialog, IdCustomer])

    // useEffect(() => {
    //     if (values?.Pais) {
    //       setValues((prevValues) => ({...prevValues, RTN: '' }));
    //     }
    // }, [values.Pais]);

    const headerTittle = IdCustomer ? 'Editar Cliente' : 'Agregar Cliente';


    return (
        <Dialog visible={clientesDialog} onHide={hideDialog} header={headerTittle}>
            <Loader loading={loading} querySelector={'#RegistroCliente'}/>
            <div id ='RegistroCliente'>
                <Toast ref={toast} />
                    <div>
                        <Card
                            titulo={<h4>Información Cliente</h4>}
                            contenido={<div>

                                    <div className='d-flex p-3 px-1' style={{ gap: 10, flexWrap: 'wrap', rowGap: 20 }}>
                                        <div className="field" style={{ width: '16.5rem' }}>
                                            <span className="p-float-label p-input-icon-right">
                                                <InputText id="righticon"
                                                    value={values?.CodigoCliente}
                                                    onChange={handleInputChange}
                                                    name={'CodigoCliente'}
                                                    style={{ width: '16.5rem' }}
                                                    // disabled
                                                />
                                                <label htmlFor="righticon">Código Cliente</label>
                                            </span>
                                        </div>

                                        <div className="field">
                                            <span className="p-float-label p-input-icon-right">
                                                <InputText id="righticon"
                                                    value={values?.CustomerName}
                                                    onChange={handleInputChange}
                                                    name={'CustomerName'}
                                                    style={{ width: '100%' }}
                                                    className={error.CustomerName ? "p-invalid" : ""}
                                                />
                                                <label htmlFor="righticon">Nombre Cliente</label>
                                            </span>
                                        </div>

                                        <div className="field">
                                            <span className="p-float-label p-input-icon-right">
                                                <InputText id="righticon"
                                                    value={values?.Abreviacion}
                                                    onChange={handleInputChange}
                                                    name={'Abreviacion'}
                                                    style={{ width: '100%' }}
                                                    className={error.Abreviacion ? "p-invalid" : ""}
                                                />
                                                <label htmlFor="righticon">Abreviación</label>
                                            </span>
                                        </div>

                                        <div className="field">
                                            <span className="p-float-label p-input-icon-right">
                                            <Calendar
                                                value={values.DateCreate} 
                                                onChange={(e) => handleInputChange(e, 'DateCreate')}
                                                style={{ width: '100%' }}
                                                showIcon
                                                disabled>
                                            </Calendar>
                                            <label htmlFor="dropdown">Fecha Creado</label>
                                            </span>
                                        </div>

                                        {/* <div className="field">
                                            <AutoCompleteDropdown
                                                name={"Estado"}
                                                value={values.Estado}
                                                items={estados}
                                                field={"StatusName"}
                                                label={"Estado"}
                                                style={{ width: '100%' }}
                                                handleInputChange={handleInputChange}
                                                className={error.Estado && 'p-invalid'}
                                            />
                                        </div> */}
                                    </div>

                                    <div className='d-flex p-3 px-1' style={{ gap: 10, flexWrap: 'wrap', rowGap: 20 }}>
                                        <div className="field">
                                            <AutoCompleteDropdown
                                                name={"Pais"}
                                                value={values?.Pais}
                                                label={"País"}
                                                items={Countries}
                                                field={"Name"}
                                                style={{ width: '100%' }}
                                                handleInputChange={handleInputChange}
                                                className={error.Pais ? "p-invalid" : ""}
                                            />
                                        </div>

                                        {/* <div className="field">
                                            <span className="p-float-label p-input-icon-right">
                                                <InputText id="righticon"
                                                    value={values?.Country}
                                                    onChange={handleInputChange}
                                                    name={'Country'}
                                                    style={{ width: '100%' }}
                                                    disabled
                                                />
                                                <label htmlFor="righticon">País</label>
                                            </span>
                                        </div> */}

                                        {/* <div className="field">
                                            <span className="p-float-label p-input-icon-right">
                                                <InputText id="righticon"
                                                    value={values?.State}
                                                    onChange={handleInputChange}
                                                    name={'State'}
                                                    style={{ width: '100%' }}
                                                    className={error.State ? "p-invalid" : ""}
                                                />
                                                <label htmlFor="righticon">Estado</label>
                                            </span>
                                        </div> */}

                                        <div className="field">
                                            <span className="p-float-label p-input-icon-right">
                                                <InputText id="righticon"
                                                    value={values?.City}
                                                    onChange={handleInputChange}
                                                    name={'City'}
                                                    style={{ width: '100%' }}
                                                    className={error.City ? "p-invalid" : ""}
                                                />
                                                <label htmlFor="righticon">Ciudad</label>
                                            </span>
                                        </div>

                                        {/* <div className="field">
                                            <span className="p-float-label p-input-icon-right">
                                                <InputText id="righticon"
                                                    value={values?.ZipCode}
                                                    onChange={handleInputChange}
                                                    name={'ZipCode'}
                                                    style={{ width: '100%' }}
                                                />
                                                <label htmlFor="righticon">ZipCode</label>
                                            </span>
                                        </div> */}

                                        {/* SI EL PAIS ES HONDURAS MUESTRA InputMask REQUIRIENDO 14 DIGITOS */}
                                        {values?.Pais?.Id === IdHonduras ? (
                                            <div className="field">
                                                <span className="p-float-label p-input-icon-right">
                                                    <InputMask id="righticon"
                                                        mask="9999-9999-999999"
                                                        value={values?.RTN}
                                                        onChange={handleInputChange}
                                                        name={'RTN'}
                                                        style={{ width: '100%' }}
                                                        className={error.RTN ? "p-invalid" : ""}
                                                    />
                                                    <label htmlFor="righticon">RTN</label>
                                                </span>
                                            </div>
                                            ) : (
                                            <div className="field">
                                                <span className="p-float-label p-input-icon-right">
                                                    <InputText id="righticon"
                                                        value={values?.RTN}
                                                        onChange={handleInputChange}
                                                        name={'RTN'}
                                                        style={{ width: '100%' }}
                                                        className={error.RTN ? "p-invalid" : ""}
                                                    />
                                                    <label htmlFor="righticon">RTN</label>
                                                </span>
                                            </div>
                                        )}

                                    </div>

                                    <div className='d-flex p-3 px-1' style={{ gap: 10, flexWrap: 'wrap', rowGap: 20 }}>
                                        <div className="field">
                                            <span className="p-float-label p-input-icon-right col-12">
                                                <InputTextarea id="righticon"
                                                    value={values?.Address}
                                                    onChange={handleInputChange}
                                                    name={'Address'}
                                                    style={{ width: '100%' }}
                                                    rows={2} cols={56}
                                                    className={error.Address ? "p-invalid" : ""}
                                                />
                                                <label htmlFor="righticon">Dirección</label>
                                            </span>
                                        </div>

                                        <div className="field">
                                            <span className="p-float-label p-input-icon-right col-12">
                                                <InputTextarea id="righticon"
                                                    value={values?.Comments}
                                                    onChange={handleInputChange}
                                                    name={'Comments'}
                                                    style={{ width: '100%' }}
                                                    rows={2} cols={51}
                                                />
                                                <label htmlFor="righticon">Comentario</label>
                                            </span>
                                        </div>

                                        <div class="align-self-center">
                                            <div className="field">
                                                <span className="p-float-label p-input-icon-right col-12">
                                                    <Checkbox id="righticon"
                                                        checked={values?.IsShipTo}
                                                        onChange={handleInputChange}
                                                        name={'IsShipTo'}
                                                        style={{ width: '100%' }}
                                                    />
                                                    <label htmlFor="righticon" style={{ marginLeft: 10 }}>IsShipTo</label>
                                                </span>
                                            </div>
                                        </div>

                                        <div class="align-self-center">
                                            <div className="field" style={{ marginLeft: 80 }}>
                                                <span className="p-float-label p-input-icon-right col-12">
                                                    <Checkbox id="righticon"
                                                        checked={values?.IsBillTo}
                                                        onChange={handleInputChange}
                                                        name={'IsBillTo'}
                                                        style={{ width: '100%' }}
                                                    />
                                                    <label htmlFor="righticon" style={{ marginLeft: 10 }}>IsBillTo</label>
                                                </span>
                                            </div>
                                        </div>
                                    </div>
                            </div>}
                        />
                        
                        {/* <Card
                            titulo={<h4>Ubicación Cliente</h4>}
                            contenido={<div className='d-flex p-3 px-1' style={{ gap: 10, flexWrap: 'wrap', rowGap: 20 }}>

                                    <div className="field">
                                        <AutoCompleteDropdown
                                            name={"Pais"}
                                            value={values?.Pais}
                                            label={"País"}
                                            items={Countries}
                                            field={"Name"}
                                            style={{ width: '100%' }}
                                            handleInputChange={handleInputChange}
                                            className={error.Pais ? "p-invalid" : ""}
                                        />
                                    </div>

                                    <div className="field">
                                        <span className="p-float-label p-input-icon-right col-12">
                                            <InputText id="righticon"
                                                value={values?.Country}
                                                onChange={handleInputChange}
                                                name={'Country'}
                                                style={{ width: '100%' }}
                                                disabled
                                            />
                                            <label htmlFor="righticon">País</label>
                                        </span>
                                    </div>

                                    <div className="field">
                                        <span className="p-float-label p-input-icon-right col-12">
                                            <InputText id="righticon"
                                                value={values?.State}
                                                onChange={handleInputChange}
                                                name={'State'}
                                                style={{ width: '100%' }}
                                                className={error.State ? "p-invalid" : ""}
                                            />
                                            <label htmlFor="righticon">Estado</label>
                                        </span>
                                    </div>

                                    <div className="field">
                                        <span className="p-float-label p-input-icon-right col-12">
                                            <InputText id="righticon"
                                                value={values?.City}
                                                onChange={handleInputChange}
                                                name={'City'}
                                                style={{ width: '100%' }}
                                                className={error.City ? "p-invalid" : ""}
                                            />
                                            <label htmlFor="righticon">Ciudad</label>
                                        </span>
                                    </div>

                                    <div className="field">
                                        <span className="p-float-label p-input-icon-right col-12">
                                            <InputText id="righticon"
                                                value={values?.ZipCode}
                                                onChange={handleInputChange}
                                                name={'ZipCode'}
                                                style={{ width: '100%' }}
                                            />
                                            <label htmlFor="righticon">ZipCode</label>
                                        </span>
                                    </div>

                                    <div className="field">
                                        <span className="p-float-label p-input-icon-right col-12">
                                            <InputTextarea id="righticon"
                                                value={values?.Address}
                                                onChange={handleInputChange}
                                                name={'Address'}
                                                style={{ width: '100%' }}
                                                rows={2} cols={50}
                                                className={error.Address ? "p-invalid" : ""}
                                            />
                                            <label htmlFor="righticon">Dirección</label>
                                        </span>
                                    </div>
                            </div>}
                        /> */}

                        <Card
                            titulo={<h4>Contacto Cliente</h4>}
                            contenido={<div className='d-flex p-3 px-1' style={{ gap: 10, flexWrap: 'wrap', rowGap: 20 }}>

                                    <div className="field">
                                        <span className="p-float-label p-input-icon-right col-12">
                                            <InputText id="righticon"
                                                value={values?.Tel}
                                                onChange={handleInputChange}
                                                name={'Tel'}
                                                style={{ width: '100%' }}
                                                className={error.Tel ? "p-invalid" : ""}
                                            />
                                            <label htmlFor="righticon">Telefono</label>
                                        </span>
                                    </div>

                                    <div className="field">
                                        <span className="p-float-label p-input-icon-right col-12">
                                            <InputText id="righticon"
                                                value={values?.Email}
                                                onChange={handleInputChange}
                                                name={'Email'}
                                                style={{ width: '100%' }}
                                                className={error.Email ? "p-invalid" : ""}
                                            />
                                            <label htmlFor="righticon">Correo</label>
                                        </span>
                                    </div>

                                    <div className="field">
                                        <span className="p-float-label p-input-icon-right col-12">
                                            <InputText id="righticon"
                                                value={values?.Contact}
                                                onChange={handleInputChange}
                                                name={'Contact'}
                                                style={{ width: '100%' }}
                                                className={error.Contact ? "p-invalid" : ""}
                                            />
                                            <label htmlFor="righticon">Contacto</label>
                                        </span>
                                    </div>

                                    <div className="field">
                                        <span className="p-float-label p-input-icon-right col-12">
                                            <InputText id="righticon"
                                                value={values?.Tel2}
                                                onChange={handleInputChange}
                                                name={'Tel2'}
                                                style={{ width: '100%' }}
                                                className={error.Tel2 ? "p-invalid" : ""}
                                            />
                                            <label htmlFor="righticon">Telefono 2</label>
                                        </span>
                                    </div>

                                    <div className="field">
                                        <span className="p-float-label p-input-icon-right col-12">
                                            <InputText id="righticon"
                                                value={values?.Email2}
                                                onChange={handleInputChange}
                                                name={'Email2'}
                                                style={{ width: '100%' }}
                                                className={error.Email2 ? "p-invalid" : ""}
                                            />
                                            <label htmlFor="righticon">Correo 2</label>
                                        </span>
                                    </div>

                                    <div className="field">
                                        <span className="p-float-label p-input-icon-right col-12">
                                            <InputText id="righticon"
                                                value={values?.Contact2}
                                                onChange={handleInputChange}
                                                name={'Contact2'}
                                                style={{ width: '100%' }}
                                                className={error.Contact2 ? "p-invalid" : ""}
                                            />
                                            <label htmlFor="righticon">Contacto 2</label>
                                        </span>
                                    </div>

                            </div>}
                        />

                        <Card
                            titulo={<h4>Información de Facturación</h4>}
                            contenido={(
                                <div className='d-flex p-3 px-1' style={{ gap: 10, flexWrap: 'wrap', rowGap: 20 }}>
                                    
                                    <div className="field">
                                        <AutoCompleteDropdown
                                            name={"TiPago"}
                                            value={values?.TiPago}
                                            label={"Tipo Pago"}
                                            enable={Finanzas?.Finanzas === true}
                                            items={tipoPagos}
                                            field={"Nombre"}
                                            style={{ width: '100%' }}
                                            handleInputChange={handleInputChange}
                                            className={error.TiPago ? "p-invalid" : ""}
                                        />
                                    </div>

                                    <div className="field">
                                        <AutoCompleteDropdown
                                            name={"Units"}
                                            value={values?.Units}
                                            label={"Unidades"}
                                            enable={Finanzas?.Finanzas === true}
                                            items={unidades}
                                            field={"UnitName"}
                                            style={{ width: '100%' }}
                                            handleInputChange={handleInputChange}
                                            className={error.Units ? "p-invalid" : ""}
                                        />
                                    </div>

                                    <div className="field">
                                        <AutoCompleteDropdown
                                            name={"TerminosP"}
                                            value={values?.TerminosP}
                                            label={"Terminos"}
                                            enable={Finanzas?.Finanzas === true}
                                            items={terminosPayment}
                                            field={"TermName"}
                                            style={{ width: '100%' }}
                                            handleInputChange={handleInputChange}
                                            className={error.TerminosP ? "p-invalid" : ""}
                                        />
                                    </div>

                                    <div className="field">
                                        <AutoCompleteDropdown
                                            name={"TerminosI"}
                                            value={values?.TerminosI}
                                            label={"Terminos Flete"}
                                            items={terminosIncoterms}
                                            field={"TermName"}
                                            enable={Finanzas?.Finanzas === true}
                                            style={{ width: '100%' }}
                                            handleInputChange={handleInputChange}
                                            className={error.TerminosI ? "p-invalid" : ""}
                                        />
                                    </div>

                                    <div className="field">
                                        <span className="p-float-label p-input-icon-right col-12">
                                            <InputNumber id="righticon"
                                                value={values?.CreditLimit}
                                                onChange={handleInputChange}
                                                name={'CreditLimit'}
                                                disabled={!Finanzas?.Finanzas}
                                                style={{ width: '100%' }}
                                            />
                                            <label htmlFor="righticon">Limite de Credito</label>
                                        </span>
                                    </div>

                                    <div className="field">
                                        <span className="p-float-label p-input-icon-right col-12">
                                            <InputNumber id="righticon"
                                                value={values?.Porcentaje}
                                                disabled={!Finanzas?.Finanzas}
                                                onChange={handleInputChange}
                                                name={'Porcentaje'}
                                                style={{ width: '100%' }}
                                                suffix="%"
                                            />
                                            <label htmlFor="righticon">% Tolerancia Exportación</label>
                                        </span>
                                    </div>


                                    {Finanzas?.Finanzas && (
                                        <div className="field">
                                            <span className="p-float-label p-input-icon-right col-12">
                                                <InputNumber id="righticon"
                                                    value={values?.PorcentajePenalizacion}
                                                    onChange={handleInputChange}
                                                    name={'PorcentajePenalizacion'}
                                                    disabled={!Finanzas?.Finanzas}
                                                    style={{ width: '100%' }}
                                                    suffix="%"
                                                    className={error.PorcentajePenalizacion ? "p-invalid" : ""}
                                                />
                                                <label htmlFor="PorcentajePenalizacion">% Penalización</label>
                                            </span>
                                        </div>
                                    )}

                                </div>
                            )}
                        />

                        <div className='col-12 mt-2' style={{ display: 'flex', justifyContent: 'flex-end' }}>
                            <Button className='p-button-danger mx-1' icon="pi pi-times" loading={loading} onClick={hideDialog} label='Cancelar' />
                            <Button className='p-button-success mx-1' icon="pi pi-check" loading={loading} label='Guardar' onClick={guardarCliente} />
                        </div>
                    </div>
            </div>
        </Dialog>
    )
}

export default ModalClientes
